import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card, Input, List, Pagination, Radio, Select, Spin,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { WidthProvider, Responsive } from 'react-grid-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { faList } from '@fortawesome/pro-light-svg-icons/faList';
import { faThLarge } from '@fortawesome/pro-light-svg-icons/faThLarge';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';
import {
  gridRequestAction, gridSetFilterAction, gridSetOrder, gridInit,
} from '../../../state/actions/creators/grideable.actioncreator';
import {
  Box, ShowIf, Text,
} from '../../shared/components';
import ArticuloFotoGridBox from '../components/dataDisplay/ArticuloFotoGridBox.datadisplay';
import ArticuloFotoGridLine from '../components/dataDisplay/ArticuloFotoGridLine.datadisplay';
import { isTablet, isTotem } from '../../../helpers/device.helper';
import { debounce } from '../../../helpers/common.helper';

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const { Option } = Select;

class BuscadorArticulos extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modo: 'lista',
      textoBusqueda: '',
    };
  }

  componentDidMount() {
    const {
      gridSetFilterAction, gluedFilter, modosVisualizacion, endpoint, preload,
      searchResult, init, gridInit, modoVisualizacion,
    } = this.props;

    if (endpoint === undefined) throw 'Es necesario especificar un endpoint';
    if (init) gridInit({ endpoint });
    if (gluedFilter !== undefined) {
      gridSetFilterAction({
        endpoint,
        filters: gluedFilter,
      });
    }

    if (searchResult) {
      const previusTextSearchExists = searchResult.filters && searchResult.filters.busc_descripcion;
      if (previusTextSearchExists) {
        const textoBusqueda = searchResult.filters.busc_descripcion.valor;
        this.setState({ textoBusqueda });
      }
    }

    if (modosVisualizacion && modosVisualizacion.length > 0) {
      this.setState({ modo: 'lista' });
    }
    if (isTablet() || isTotem()) {
      this.setState({ modo: 'grid' });
    } else if (modoVisualizacion) this.setState({ modo: modoVisualizacion });

    if (preload === true) {
      this.buscarArticulos();
    }
  }

  componentDidUpdate(prevProps) {
    const { articulos: previousRequestState } = prevProps;
    const { articulos, onSearchSuccess, onSearchFailed } = this.props;
    handleSagaStatus({
      estadoPeticion: articulos,
      previousEstadoPeticion: previousRequestState,
      onWasRunningAndHasSucceded: () => {
        onSearchSuccess({ ...articulos });
      },
      onWasRunningAndHasFailed: () => {
        onSearchFailed({ ...articulos });
      },
    });
  }

  debouncedBuscar = debounce(() => {
    this.establecerFiltroYBuscar();
  }, 500);

  establecerFiltroYBuscar = () => {
    const { textoBusqueda } = this.state;
    const { gridSetFilterAction, articulos: { filters, pagination }, endpoint } = this.props;
    const { pageSize } = pagination || { pageSize: 12 };
    const nextFilters = { ...filters };
    if (textoBusqueda !== undefined) {
      nextFilters.busc_codigo_descripcion = {
        operador: 'virtual',
        valor: textoBusqueda,
      };
      gridSetFilterAction({ endpoint, filters: nextFilters });
    } else {
      gridSetFilterAction({ endpoint, filters: { busc_descripcion: undefined } });
    }

    this.buscarArticulos({ pagination: { current: 1, pageSize } });
  };

  buscarArticulos(params) {
    const { pagination } = params || { pagination: undefined };
    const {
      gridRequestAction, numeroDeArticulos, onSearchRequest, endpoint,
    } = this.props;
    const requestParams = {
      url: 'api/articulos/buscar',
      endpoint,
      limite: numeroDeArticulos,
      pagination,
    };
    onSearchRequest({ ...requestParams });
    gridRequestAction(requestParams);
  }

  cambiarOrdenacion(value) {
    const { gridSetOrder, endpoint } = this.props;
    const order = {};
    if (value != undefined) {
      order[value] = { operador: 'ASC' };
    }
    gridSetOrder({ endpoint, order });
    this.buscarArticulos();
  }

  render() {
    const { articulos, articulos: { running: peticionDeBusquedaEnCurso }, filtrosDesactivados } = this.props;
    const {
      searchable, seleccionId, modosVisualizacion, ordenable, gridSetFilterAction, endpoint,
      searchResult, containerStyle, paginationProps, bodyProps,
    } = this.props;

    const { datos, pagination } = articulos;
    const { onSeleccion, onVRClick } = this.props;
    const hayDatos = datos !== undefined && datos.length > 0;
    const { modo, textoBusqueda } = this.state;
    const { total, current, pageSize } = pagination || { total: null, current: null, pageSize: 12 };

    const cols = {
      lg: 4, md: 4, sm: 3, xs: 2, xxs: 1,
    };

    const breakpoints = {
      lg: 1200, md: 996, sm: 520, xs: 400, xxs: 0
    };

    const elementSize = 1;
    const layouts = {};
    if (hayDatos && modo === 'grid') {
      Object.keys(cols).forEach((key) => {
        const layout = [];
        let yIndex = 0;
        const colSize = cols[key];
        datos.forEach(({ id }, index) => {
          layout.push({
            i: id,
            x: (index % colSize) * elementSize,
            y: (yIndex),
            w: 1,
            h: 1,
            isDraggable: false,
            isResizable: false,
          });
          if ((layout.length % colSize) === 0) yIndex = (index % colSize) * elementSize;
        });

        layouts[key] = layout;
      });
    }

    let valorFiltroTipoArticulo;
    let valorOrdenSeleccionado;
    let valorFiltroStockUnidades = 'todos';

    if (searchResult) {
      if (searchResult.filters) {
        const { filters } = searchResult;
        if (filters['tipo.id']) {
          valorFiltroTipoArticulo = filters['tipo.id'].valor;
        }
        if (searchResult.filters['stocks.unidades_propias']) {
          valorFiltroStockUnidades = 'en_stock';
        }
      }
      if (searchResult.sorter && Object.keys(searchResult.sorter).length > 0) {
        valorOrdenSeleccionado = Object.keys(searchResult.sorter)[0];
      }
    }

    const SelectorDeOrdenacion = (
      <ShowIf condition={ordenable && ordenable.length > 0}>
        <Box mt="16" ml="16" display="inline-block">
          <Select
            dropdownStyle={{ minWidth: '180px' }}
            allowClear
            onChange={value => this.cambiarOrdenacion(value)}
            placeholder="Ordenar por"
            style={{ width: 130 }}
            value={valorOrdenSeleccionado}
          >
            { ordenable.map(({ label, value }) => <Select.Option value={value}>{label}</Select.Option>)}
          </Select>
        </Box>
      </ShowIf>
    );

    const Filtros = (
      <Box pl="16">
        <Select
          dropdownStyle={{ minWidth: '180px' }}
          allowClear
          style={{ width: '148px' }}
          onChange={(value) => {
            if (value == undefined) {
              gridSetFilterAction({
                endpoint,
                filters: { 'tipo.id': undefined },
              });
            } else {
              gridSetFilterAction({
                endpoint,
                filters: { 'tipo.id': { valor: value, operador: 'eq' } },
              });
            }
            this.buscarArticulos();
          }}
          value={valorFiltroTipoArticulo}
        >
          <Option value="3">Monturas</Option>
          <Option value="5">Sol</Option>
          <Option value="2">Lentes de Contacto</Option>
          <Option value="1">Lentes</Option>
          <Option value="4">Varios</Option>
          <Option value="6">Audifonos</Option>
          <Option value="7">Varios Audio</Option>
        </Select>
      </Box>
    );

    const Ordenacion = (
      <Box>
        <Box display="inline-block" mt="16">
          <Box pl="16">
            <Radio.Group
              onChange={(event) => {
                const { value } = event.target;
                if (value === 'en_stock') {
                  gridSetFilterAction({
                    endpoint,
                    filters: { 'stocks.unidades_propias': { operador: 'gt', valor: 0 } },
                  });
                } else {
                  gridSetFilterAction({
                    endpoint,
                    filters: { 'stocks.unidades_propias': undefined },
                  });
                }
                this.buscarArticulos();
              }}
              value={valorFiltroStockUnidades}
            >
              <Radio.Button value="en_stock">
                <Text translationId="articulos.en_stock" />
              </Radio.Button>
              <Radio.Button value="todos">
                <Text translationId="generico.todos" />
              </Radio.Button>
            </Radio.Group>
          </Box>
        </Box>
        { SelectorDeOrdenacion }
        <ShowIf condition>
          <Box mx="16" display="inline-block" mt="16">
            <Radio.Group onChange={(event) => {
              const { value } = event.target;
              this.setState({ modo: value });
            }}
            >
              <ShowIf condition={modosVisualizacion.includes('lista')}>
                <Radio.Button value="lista">
                  <FontAwesomeIcon icon={faList} />
                </Radio.Button>
              </ShowIf>
              <ShowIf condition={modosVisualizacion.includes('grid')}>
                <Radio.Button value="grid">
                  <FontAwesomeIcon icon={faThLarge} />
                </Radio.Button>
              </ShowIf>
            </Radio.Group>
          </Box>
        </ShowIf>
      </Box>
    );

    const FiltrosYOrdenacion = (filtrosDesactivados === true) ? null : (
      <Box style={{ textAlign: 'right' }}>
        <Box mt="16" display="inline-block" style={{ width: '128px', float: 'left' }}>{ Filtros }</Box>
        <Box display="inline-block">
          { Ordenacion }
        </Box>
      </Box>
    );

    const ArticulosModoLista = (
      <Box px="16" pb="16">
        <List
          itemLayout="horizontal"
          dataSource={datos}
          renderItem={(articulo) => {
            const {
              id: articuloId,
            } = articulo;
            return (
              <List.Item style={{ cursor: 'pointer' }}>
                <ArticuloFotoGridLine
                  selected={seleccionId === articuloId}
                  key={articuloId}
                  articulo={articulo}
                  onClick={() => {
                    onSeleccion({ articulo });
                  }}
                />
              </List.Item>
            );
          }}
        />
      </Box>
    );

    const ArticulosModoGrid = (
      <ResponsiveReactGridLayout
        rowHeight={268}
        margin={[16, 16]}
        onLayoutChange={layout => this.setState({ layout })}
        onBreakpointChange={(breakpoint, cols) => this.setState({ breakpoint, cols })}
        className="layout"
        cols={cols}
        breakpoints={breakpoints}
        layouts={layouts}
      >
        {
          datos && datos.map((articulo) => {
            const { id: articuloId, fotoSrc } = articulo;
            const photoSrc = fotoSrc;
            return (
              <ArticuloFotoGridBox
                selected={seleccionId === articuloId}
                key={articuloId}
                photoSrc={photoSrc}
                articulo={articulo}
                onVRClick={onVRClick}
                onClick={() => {
                  onSeleccion({ articulo });
                }}
              />
            );
          })
        }
      </ResponsiveReactGridLayout>
    );

    const BuscadorInput = (
      <Card>
        <Input
          readOnly={peticionDeBusquedaEnCurso}
          className={peticionDeBusquedaEnCurso === true ? 'disabled-readonly' : null}
          placeholder="Buscar articulos"
          suffix={<FontAwesomeIcon onClick={() => this.establecerFiltroYBuscar()} icon={faSearch} />}
          onChange={(e) => {
            this.setState({ textoBusqueda: e.target.value });
            if (!isTablet() && !isTotem() && e.key == 'Enter') {
              this.debouncedBuscar();
            }
          }}
          onPressEnter={() => {
            this.establecerFiltroYBuscar();
          }}
          value={textoBusqueda}
        />
      </Card>
    );

    return (
      <Box className="gioweb2-buscador-articulos">
        <Spin tip="Cargando artículos" spinning={peticionDeBusquedaEnCurso}>
          <ShowIf condition={searchable}>
            {BuscadorInput}
          </ShowIf>

          <Card {...bodyProps} bodyStyle={{ padding: 0 }}>

            {FiltrosYOrdenacion}

            <Box>
              <Box style={containerStyle}>
                <ShowIf condition={modo === 'grid'}>
                  {ArticulosModoGrid}
                </ShowIf>
                <ShowIf condition={modo !== 'grid'}>
                  {ArticulosModoLista}
                </ShowIf>
              </Box>
              <Box p="16">
                <Pagination
                  {...paginationProps}
                  defaultPageSize={pageSize}
                  defaultCurrent={current}
                  total={total}
                  onChange={(page, pageSize) => {
                    this.buscarArticulos({ pagination: { current: page, pageSize } });
                  }}
                />
              </Box>
            </Box>

          </Card>
        </Spin>
      </Box>
    );
  }
}

BuscadorArticulos.propTypes = {
  articulos: PropTypes.array,
  numeroDeArticulos: PropTypes.number,
  onSeleccion: PropTypes.func,
  onVRClick: PropTypes.func,
  onSearchRequest: PropTypes.func,
  onSearchSuccess: PropTypes.func,
  onSearchFailed: PropTypes.func,
  searchable: PropTypes.bool,
  seleccionId: PropTypes.string,
  modosVisualizacion: PropTypes.array,
  endpoint: PropTypes.string.isRequired,
  ordenable: PropTypes.array,
  filtrosDesactivados: PropTypes.bool,
  preload: PropTypes.bool,
  init: PropTypes.bool,
  containerStyle: PropTypes.any,
  paginationProps: PropTypes.any,
  bodyProps: PropTypes.any,
};

BuscadorArticulos.defaultProps = {
  seleccionId: undefined,
  articulos: PropTypes.array,
  numeroDeArticulos: 12,
  searchable: true,
  onSearchRequest: () => {
  },
  onSearchSuccess: () => {
  },
  onSearchFailed: () => {
  },
  modosVisualizacion: ['grid', 'lista'],
  ordenable: [],
  filtrosDesactivados: false,
  preload: false,
  init: false,
  containerStyle: {},
  paginationProps: {},
  bodyProps: {}
};

const mapStateToProps = (state, ownProps) => {
  const { grideable } = state;
  const { endpoint } = ownProps;
  let searchResult = {};
  if (grideable && grideable[endpoint]) {
    searchResult = grideable[endpoint];
  }
  return {
    searchResult,
    articulos: obtenerEstadoRequestDesdeSaga(grideable, endpoint),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    gridRequestAction,
    gridSetFilterAction,
    gridSetOrder,
    gridInit,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuscadorArticulos);
